import { render, staticRenderFns } from "./robotView1.vue?vue&type=template&id=7658e6c0&scoped=true"
import script from "./robotView1.vue?vue&type=script&lang=js"
export * from "./robotView1.vue?vue&type=script&lang=js"
import style0 from "./robotView1.vue?vue&type=style&index=0&id=7658e6c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7658e6c0",
  null
  
)

export default component.exports